// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7395) return "css/design_system-b07a2ff3d915332bbd23.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2456":"c9dab597ae6ab1977962","2508":"fcf709e1890ff4fc4a91","2546":"6fec498c395da02833b0","2822":"c3cc33eca0fb48afe117","6862":"e61a0b5836777ee34743","9127":"56595edd1c39fe3096a3"}[chunkId] + ".css";
};